@if (isSerialNumberResult(searchResult)) {
    <img
        class="product-image"
        [src]="searchResult.pictureUrl"
        (load)="productImageHasLoaded = true"
        (onerror)="productImageHasLoaded = true"
        [alt]="
            productImageHasLoaded
                ? ('PRODUCT.HEADER_PICTURE.ALT'
                  | translate
                      : {
                            productName: searchResult.productName,
                            catalogDescription: searchResult.catalogDescription,
                        })
                : ''
        "
        [title]="searchResult.productName + ' ' + searchResult.catalogDescription"
    />
}
@if (isSparePartListResult(searchResult)) {
    <img
        class="product-image placeholder-spacing"
        [src]="productPictureFallback"
        [alt]="
            productImageHasLoaded
                ? ('PRODUCT.HEADER_PICTURE.ALT'
                  | translate
                      : {
                            productName: searchResult.productName,
                            catalogDescription: searchResult.id,
                        })
                : ''
        "
        [title]="searchResult.productName + ' ' + searchResult.id"
    />
}
<div class="names-wrapper">
    @if (isSerialNumberResult(searchResult) && searchResult.productName) {
        <sew-headline level="3"> {{ searchResult.productName }} <br /> </sew-headline>
    }
    @if (isSerialNumberResult(searchResult) && searchResult.catalogDescription) {
        <sew-headline level="3"> {{ searchResult.catalogDescription }} </sew-headline>
    }
    @if (isSparePartListResult(searchResult) && searchResult.productName) {
        <sew-headline level="3"> {{ searchResult.productName }} <br /> </sew-headline>
    }
    @if (isSerialNumberResult(searchResult) && searchResult.serialNumber) {
        <div class="serialnumber">
            {{ searchResult.serialNumber }}
        </div>
    }
    @if (isSparePartListResult(searchResult) && searchResult.id) {
        <div class="serialnumber">
            {{ searchResult.id }}
        </div>
    }
    @if (isSerialNumberResult(searchResult) && searchResult) {
        <ecs-safety-hint-tag-list [searchResult]="searchResult"></ecs-safety-hint-tag-list>
    }
</div>
@if (searchResult) {
    <div class="buttons-wrapper">
        @if (isSerialNumberResult(searchResult)) {
            @if (searchResult.isOrderable) {
                <sew-button
                    #basketButton
                    (click)="addToBasket(searchResult.serialNumber)"
                    hierarchy="primary"
                    website
                    class="shopping-cart-button"
                    icon="shopping-cart"
                >
                    <button>
                        <span class="shopping-cart-label">{{ 'PRODUCT.ADD_TO_BASKET' | translate }}</span>
                    </button>
                </sew-button>
            } @else {
                @if (searchResult) {
                    <sew-button
                        size="xs"
                        hierarchy="primary"
                        website
                        class="shopping-cart-button"
                        icon="shopping-cart"
                    >
                        <button disabled>
                            <span class="shopping-cart-label">{{ 'PRODUCT.ADD_TO_BASKET' | translate }}</span>
                        </button>
                    </sew-button>
                }
            }

            <!-- @if (isLoggedIn) {
                <sew-button
                    #wishlistButton
                    class="wishlist-button"
                    size="s"
                    hierarchy="secondary"
                    icon="star"
                    show-icon-only
                >
                    <button (click)="addToWishlist(searchResult.serialNumber)"></button>
                </sew-button>
            } -->

            <sew-button
                id="mobile-product-actions-trigger"
                class="mobile-actions-trigger"
                size="s"
                hierarchy="secondary"
                icon="dots-vertically"
                show-icon-only
            >
                <button
                    type="button"
                    (click)="toggleMobileActionsMenu()"
                    [attr.aria-expanded]="mobileActionsMenuOpen"
                    aria-label="{{ 'ECS.PRODUCT.ACTIONS' | translate }}"
                ></button>
            </sew-button>

            <sew-popover-menu
                class="mobile-actions-popover"
                menuFor="mobile-product-actions-trigger"
                [open]="mobileActionsMenuOpen"
                (menuClose)="closeMobileActionsMenu()"
            >
                <!-- <sew-menu-item-2 class="wishlist-menu-item" icon="star">
                    <a
                        type="link"
                        target="_blank"
                        rel="noopener noreferrer"
                        oscTrackClick="product.addToWishlist"
                        (click)="closeMobileActionsMenu(); addToWishlist(searchResult.serialNumber)"
                    >
                        {{ 'PRODUCT.WISHLIST_ADD' | translate }}
                    </a>
                </sew-menu-item-2> -->
                <sew-menu-item-2 icon="document">
                    <a
                        type="link"
                        target="_blank"
                        rel="noopener noreferrer"
                        [href]="showProductDataUrl | async"
                        oscTrackClick="product.showProductData"
                        (click)="closeMobileActionsMenu()"
                    >
                        {{ 'ACTION.SHOW_PRODUCT_DATA' | translate }}
                    </a>
                </sew-menu-item-2>
                <sew-menu-item-2 icon="documentation">
                    <a
                        type="link"
                        target="_blank"
                        rel="noopener noreferrer"
                        [href]="showDocumentationUrl | async"
                        oscTrackClick="product.showDocumentation"
                        (click)="closeMobileActionsMenu()"
                    >
                        {{ 'ACTION.SHOW_DOCUMENTATION' | translate }}
                    </a>
                </sew-menu-item-2>
                <sew-menu-item-2 icon="tools">
                    <a
                        type="link"
                        target="_blank"
                        rel="noopener noreferrer"
                        [href]="requestRepairServiceUrl"
                        oscTrackClick="product.requestRepairService"
                        (click)="closeMobileActionsMenu()"
                    >
                        {{ 'ACTION.REQUEST_REPAIR_SERVICE' | translate }}
                    </a>
                </sew-menu-item-2>
            </sew-popover-menu>
        }
    </div>
}

<!-- separate disabled order button without any function - prevent users from executing addToBasket by removing the disabled attribute -->

<!-- TODO: Add Translation and Links -->
<!-- TODO: Beta Test rollback -->
@if (isSerialNumberResult(searchResult)) {
    <div class="documentation-and-service-links">
        <div class="additional-information-box">
            <div class="additional-information-headline">{{ 'ECS.LINKS_TITLE' | translate }}</div>
            <div class="link-container">
                <div class="link-row">
                    <sew-link icon="document">
                        <a
                            type="link"
                            target="_blank"
                            rel="noopener noreferrer"
                            [href]="showProductDataUrl | async"
                            oscTrackClick="product.showProductData"
                        >
                            {{ 'ACTION.SHOW_PRODUCT_DATA' | translate }}
                        </a>
                    </sew-link>
                </div>
                <div class="link-row">
                    <sew-link icon="documentation">
                        <a
                            type="link"
                            target="_blank"
                            rel="noopener noreferrer"
                            [href]="showDocumentationUrl | async"
                            oscTrackClick="product.showDocumentation"
                        >
                            {{ 'ACTION.SHOW_DOCUMENTATION' | translate }}
                        </a>
                    </sew-link>
                </div>
                <div class="link-row">
                    <sew-link icon="tools">
                        <a
                            type="link"
                            target="_blank"
                            rel="noopener noreferrer"
                            [href]="requestRepairServiceUrl"
                            oscTrackClick="product.requestRepairService"
                        >
                            {{ 'ACTION.REQUEST_REPAIR_SERVICE' | translate }}
                        </a>
                    </sew-link>
                </div>
            </div>
        </div>
    </div>
}

<!-- TODO: *ngIf="" if data is undefined - same for skeleton -->
<!-- TODO: Beta Test rollback -->
<span class="productdata-link" style="display: none; height: 0">{{ 'PRODUCT.SHOW_DATA' | translate }}</span>

<!-- Product Image Skeleton -->
@if (
    !isSparePartListResult(searchResult) &&
    ((isSerialNumberResult(searchResult) && !searchResult.pictureUrl) || !productImageHasLoaded)
) {
    <sew-skeleton class="product-image image-skeleton"></sew-skeleton>
}

<!-- TODO: check with Fabian Sarbacher if skeletons are required or not. Remove if unnecessary. -->
<!-- Product Data Skeleton -->
<!-- <div *ngIf="!searchResult?.productName" class="names-wrapper">
<sew-skeleton class="product-data-skeleton-top"></sew-skeleton>
<sew-skeleton class="product-data-skeleton-middle"></sew-skeleton>
</div> -->

<!-- TODO: *ngIf="expression" if data is undefined -->
@if (false) {
    <sew-skeleton class="productdata-link productdata-link-skeleton"></sew-skeleton>
}

<!-- Buttons Skeleton -->
@if (isSerialNumberResult(searchResult) && !searchResult.serialNumber) {
    <div class="buttons-wrapper">
        <sew-skeleton class="shopping-card-button-skeleton"></sew-skeleton>
        <!-- TODO: check if hide when searchResult?.serialNumber !== undefined still correct -->
        <!-- <sew-skeleton class="wishlist-skeleton"></sew-skeleton> -->
    </div>
}

<!-- Buttons Skeleton -->
@if (isSerialNumberResult(searchResult) && !searchResult.serialNumber) {
    <div class="documentation-and-service-links">
        <div class="link-container">
            <sew-skeleton></sew-skeleton>
            <sew-skeleton></sew-skeleton>
            <sew-skeleton></sew-skeleton>
        </div>
    </div>
}
